<template>
  <div>
    <section class="hero is-info">
      <!-- Hero head: will stick at the top -->
      <div class="hero-head">
      </div>

      <!-- Hero content: will be in the middle -->
      <div>
        <slot name="hero-body">
        </slot>
      </div>

      <!-- Hero footer: will stick at the bottom -->
      <div class="hero-foot">
        <slot name="hero-foot">
        </slot>
      </div>
    </section>

      <div class="container">
        <slot/>
      </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutBasic',
  components: {}
}
</script>
